module.exports = __webpack_public_path__ + "img/20200911_140654.6453bc0a.jpg";